module.exports = __webpack_public_path__ + "static/pic03-e913fdcc402d60b77b0eec4945ac08d0.jpg";